import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Chip,
  CircularProgress,
  Grid,
  Stack,
  TextField,
  Typography,
  Card,
  CardContent,
} from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import { gql, useMutation } from "@apollo/client";
import { useParams } from "react-router-dom";
import { IMAGES_API_URL } from "./constants";
import { getBranding } from "./utils/branding";

export default function SearchBadge() {
  const { eventId } = useParams(); // Get eventId from URL params
  const { control, handleSubmit, setError, clearErrors } = useForm();

  const [searchId, setSearchId] = useState(null);
  const [certificates, setCertificates] = useState(null);
  const [showButton, setShowButton] = useState(false);
  const [role, setRole] = useState();

  const [searchCertificateFromAllRole, { loading, error }] = useMutation(gql`
    mutation searchCertificateFromAllRole(
      $eventId: String!
      $searchData: String!
    ) {
      searchCertificateFromAllRole(eventId: $eventId, searchData: $searchData)
    }
  `);

  const handleSearch = async (variables) => {
    /*
     * ONE BOX (owner 2026-10-23). It used to be an Email field, an "OR" divider and a Mobile
     * field — two inputs for one question, where the person already knows which of the two they
     * are typing. The id was not accepted at all, and it is the one a delegate holding their
     * badge or their confirmation email is most likely to have in front of them.
     */
    const searchData = String(variables.searchData ?? "").trim();
    if (!searchData) {
      setError("formError", {
        message: "Enter your email, mobile number or registration ID.",
      });
      return;
    }

    try {
      const response = await searchCertificateFromAllRole({
        variables: {
          searchData,
          eventId,
        },
      });

      // Parse the response data
      const parsedData = JSON.parse(response.data.searchCertificateFromAllRole);
      console.log(">>>>", parsedData);
      setCertificates(parsedData); // Set searchId from parsed response
      // setRole(role); // Set role from parsed response
      setShowButton(parsedData?.length > 0); // Show button if id exists
    } catch (err) {
      console.error("Failed to search for badge.", err);
      setCertificates(null);
    }
  };

  // const downloadUrl = `https://api-reg.eventegration.com/graphql/badge/${eventId}/${role}/${searchId}`;

  const handleDownload = (downloadUrl) => {
    window.open(downloadUrl);
    // setShowButton(null);
  };
  const Footer = () => {
    const branding = getBranding(eventId);
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          mt: 4,
        }}
      >
        <Typography variant="body2" color="textSecondary">
          Powered by{" "}
          <a
            href={branding.websiteUrl}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: "gold",
              textDecoration: "none",
              fontWeight: "bold",
            }}
          >
            {branding.isXTravex ? branding.companyName : "Evente"}
          </a>
          {!branding.isXTravex && (
            <a
              href={branding.websiteUrl}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: "#blue",
                textDecoration: "none",
                fontWeight: "bold",
              }}
            >
              gration
            </a>
          )}
        </Typography>
      </Box>
    );
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "80vh",
          bgcolor: "#f5f5f5",
          p: 3,
        }}
      >
        <Card
          sx={{
            maxWidth: 400,
            p: 3,
            borderRadius: 3,
            boxShadow: 3,
          }}
        >
          {!showButton ? (
            <CardContent>
              {eventId && eventId != "1638075500" && (
                <img
                  src={`${IMAGES_API_URL}logo/${eventId}.png`}
                  width="100%"
                  height={"100px"}
                  style={{ objectFit: "contain" }}
                  alt="Logo"
                  onError={(e) => {
                    e.target.style.display = "none";
                  }}
                />
              )}
              <Typography
                variant="h5"
                textAlign="center"
                gutterBottom
                sx={{ fontWeight: "bold", color: "#2a9d8f", mt: 2 }}
              >
                Search Your Certificate
              </Typography>
              <Typography variant="subtitle1" textAlign="center" gutterBottom>
                Enter your registered email, mobile number or registration ID.
              </Typography>
              <form
                onSubmit={handleSubmit((data) => {
                  clearErrors("formError");
                  handleSearch(data);
                })}
              >
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Controller
                      name="searchData"
                      control={control}
                      defaultValue=""
                      render={({ field }) => (
                        <TextField
                          {...field}
                          label="Email, mobile number or registration ID"
                          /* `text`, deliberately: `type="number"` on the old mobile field
                             stripped a leading +, refused an id with letters, and turned the
                             box into a spinner on desktop. */
                          type="text"
                          autoFocus
                          fullWidth
                          sx={{ bgcolor: "#fff" }}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Button
                      type="submit"
                      variant="contained"
                      fullWidth
                      sx={{
                        bgcolor: "#2a9d8f",
                        "&:hover": { bgcolor: "#21867a" },
                      }}
                    >
                      Search &nbsp;{" "}
                      {loading && (
                        <CircularProgress color="inherit" size={20} />
                      )}
                    </Button>
                  </Grid>
                  {error && (
                    <Stack
                      direction="row"
                      justifyContent="center"
                      sx={{ width: "100%" }}
                    >
                      <Typography
                        textAlign="center"
                        color="error"
                        sx={{ mt: 2 }}
                      >
                        {error.message}
                      </Typography>
                    </Stack>
                  )}
                  <Grid item xs={12}>
                    <Typography
                      variant="body2"
                      color="error"
                      textAlign="center"
                      sx={{ mt: 2 }}
                    >
                      {control._formState.errors?.formError?.message}
                    </Typography>
                  </Grid>
                </Grid>
              </form>
            </CardContent>
          ) : (
            <CardContent>
              <Stack direction="column" justifyContent="center" spacing={3}>
                <Typography
                  variant="h5"
                  textAlign="center"
                  gutterBottom
                  sx={{ fontWeight: "bold", color: "#2a9d8f" }}
                >
                  Download Your Certificate
                </Typography>
                {/*
                  WHOSE CERTIFICATE, AND FOR WHAT.
                  This printed "Download Certificate 1" and "Download Certificate 2" with the
                  role commented out — so somebody registered as a delegate AND a speaker could
                  not tell which button was which, and had to download both to find out.
                */}
                {certificates?.map((certificate, i) => (
                  <Stack
                    direction="column"
                    key={`${certificate.role}:${certificate.id}:${i}`}
                    spacing={1}
                    sx={{
                      border: "1px solid #e0e0e0",
                      borderRadius: 2,
                      p: 2,
                    }}
                  >
                    {certificate.name && (
                      <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                        {certificate.name}
                      </Typography>
                    )}
                    <Stack direction="row" spacing={1} alignItems="center">
                      <Chip
                        label={String(certificate.role || "").replace(/^./, (c) =>
                          c.toUpperCase()
                        )}
                        size="small"
                        sx={{ bgcolor: "#e8f5f3", color: "#2a9d8f" }}
                      />
                      <Typography variant="caption" color="text.secondary">
                        ID {certificate.id}
                      </Typography>
                    </Stack>
                    <Button
                      onClick={() =>
                        handleDownload(
                          `https://api-reg.eventegration.com/graphql/certificate/${eventId}/${certificate.role}/${certificate.id}`
                        )
                      }
                      variant="contained"
                      color="success"
                      fullWidth
                    >
                      Download certificate
                    </Button>
                  </Stack>
                ))}
              </Stack>
            </CardContent>
          )}
        </Card>
      </Box>
      <Footer />
    </>
  );
}
